import React, { Component } from 'react';


import {
    Container,
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    Col,
    Row,
    ModalFooter
} from 'reactstrap';

export class Recupero extends Component {
    state =
        {
            email:""
        }

    handleMail = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

        render() {
        return (
            <Container fluid style={{ color: "#011e41" }}>            
                <Col>
                    <FormGroup className="row">
                            <Label for="mail" className="col-3 col-form-label" style={{ color: '#011e41' }}>Email</Label>
                            <Col className="col-9">
                                <Input type="text" name="mail" id="mail" placeholder="esempio@email.com" onChange={this.handleMail} />
                            </Col>
                    </FormGroup>                 
                </Col>
            </Container>
            )

    } 
}


// WEBPACK FOOTER //
// ./src/components/Utenti/Recupero.js